/** @jsx jsx */
import { useEffect, useState } from 'react';
import { jsx, Box } from 'theme-ui';

import loadScript from './loadScript';
import embeds from './embedProviders';

// This file only runs Clientside
// TODO: No idea what the second arg (_) is used for

const EmbedCustom = (componentJson, _) => {

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const { id, src, async } = embeds[componentJson.service];

    // This loadScript specifically constructs a <script> to fetch vendor JS that interacts w/ the <embed> created below
    loadScript(id, src, async, () => {
      if (isMounted) setLoaded(true);
    });
    return () => {
      isMounted = false;
    };
  });

  const InnerEmbed = () => (
    <Box
      sx={{ margin: '0 auto' }}
      dangerouslySetInnerHTML={{ __html: componentJson.embedCode }}
    />
  );

  return loaded ? <InnerEmbed /> : null;
};

export default EmbedCustom;
